import { useNavigate } from "react-router-dom";
import Button from "../components/button/Button.tsx";

const ThankYou = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full min-h-screen flex items-center justify-center bg-gradient-to-br from-blue/5 via-white to-yellow/5 px-4">
      <div className="w-full max-w-xl text-center bg-white border border-gray-100 rounded-3xl p-10 lg:p-14 shadow-soft fade-up">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-blue/10 mb-6">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#5299D3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <h2 className="text-3xl lg:text-4xl text-lightBlack font-display font-semibold tracking-tight mb-3">
          Thank you for subscribing!
        </h2>
        <p className="text-base text-gray-500 leading-relaxed">
          You can now start using the app and explore our AI chat features with your team — based on your subscription plan.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 items-center justify-center">
          <div className="w-full sm:w-auto">
            <Button
              onClick={() => navigate("/chats")}
              className="!w-full sm:!w-auto !px-8"
            >
              Start using the app
            </Button>
          </div>
          <div className="w-full sm:w-auto">
            <Button
              variant="secondary"
              onClick={() => navigate("/")}
              className="!w-full sm:!w-auto !px-8"
            >
              Back to home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
